import React from 'react';

const IconGcp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path
      fill="#CFD8DC"
      d="M30,13H18l-7,11l7,11h12l7-11L30,13z M24,29c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S26.8,29,24,29z"
    />
    <path
      fill="#2196F3"
      d="M34.8,7.2C34.3,6.5,33.5,6,32.6,6H15.4c-0.9,0-1.7,0.5-2.2,1.2l-5.8,9.5L12,24l6.3-10h20.6L34.8,7.2z M16,11c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S16.6,11,16,11z M32,11c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S32.6,11,32,11z"
    />
    <path
      fill="#FFC107"
      d="M18.3,34L7.4,16.8l-3.6,5.9c-0.5,0.8-0.5,1.9,0,2.7l9.4,15.4c0.5,0.8,1.3,1.2,2.2,1.2h9.1l5.1-8H18.3z M8,25c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S8.6,25,8,25z M16,39c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S16.6,39,16,39z"
    />
    <path fill="#1976D2" d="M7.4 16.8L12 24 14.4 20.3 8.5 15z" />
    <path fill="#F9A825" d="M24.6 42L29.7 34 24.9 34 22.6 42z" />
    <path
      fill="#DD2C00"
      d="M44.2,22.7L38.9,14h-9.2L36,24L24.6,42h8c0.9,0,1.7-0.5,2.2-1.2l9.5-15.4C44.8,24.5,44.8,23.5,44.2,22.7z M32,39c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S32.6,39,32,39z M40,25c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S40.6,25,40,25z"
    />
    <path fill="#BF360C" d="M38.9 14L29.7 14 32.2 17.9 40.1 16z" />
  </svg>
);

export default IconGcp;
